import { reduxForm, change, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { createBin, editBin, fetchBinDetail } from '../../actions/zones_actions';

import BinForm from '../../components/Inventories/binForm';

const validate = values => {
  const errors = {}
  if (!values.Name) {
      errors.Name = 'Required'
  }
  return errors
}

let binForm = reduxForm({
    form: 'binForm',
    validate
})(BinForm);

const selector = formValueSelector('binForm')

function mapStateToProps(state) {
    return {
        currentWarehouse: state.warehouses.currentWarehouse,
        currentZone: state.zones.currentZone,

        currentBin: state.zones.currentBin,
        currentBinDetail: state.zones.currentBinDetail,
        detailIsLoading: state.zones.binDetailIsLoading,
        detailError: state.zones.binDetailError,
        initialValues: state.zones.currentBinDetail,
        isCreating: state.zones.binIsCreating,
        createError: state.zones.binCreateError,
        created: state.zones.binCreated,
        isEditing: state.zones.binIsEditing,
        editError: state.zones.binEditError,
        edited: state.zones.binEdited,
        userPermissions: state.auth.userPermissions,
        initialValues: state.zones.currentBin,
    }
}

export default connect(mapStateToProps, { createBin, editBin, fetchBinDetail })(binForm)



// WEBPACK FOOTER //
// ./master/jsx/containers/Inventories/binForm.jsx